<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_viii"></a><a id="page_ix">Contents</a></p><a id="page_ix">
</a><p class="TocSb1" id="for"><a id="page_ix"></a><a href="#/xhtml/foreword#for"><i>Foreword</i> by Lisa Sharon Harper</a></p>
<p class="Toc1" id="pre"><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc1" id="ack"><a href="#/xhtml/acknowledgements#ack">Acknowledgments</a></p>
<p class="Toc1" id="int"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="Toct" id="ch-001"><span href="#/xhtml/chapter001#ch001" title="Link target outside of Sample">1.<span class="space1">Racism Is Not about Feelings or Friendship</span></span></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space1">Racism Is Not a Stand-Alone Issue</span></span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">The Unbearable Whiteness of Being</span></span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Reconciliation Begins with a Curse</span></span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">Our Spiritual Strivings</span></span></p>
<p class="Toc1a" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc1" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index of Subjects</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?30b07eee